import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "utils/analytics";

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Keyed on the RAW pathname so the page_view count is unchanged (two tokens on one route are still two
    // views). The path itself is NOT safe — /reset-password/<token>, /payment/success/<orderId> — so
    // trackPageView sanitises it, and the page_location / page_referrer it sends, through the shared
    // telemetry policy (utils/privacy/telemetryUrl, REF-6708). Attribution UTMs are captured separately via
    // the refabric_param header (see firstTouchAttribution.ts).
    trackPageView(location.pathname);
  }, [location.pathname]);
};

export default usePageTracking;
